import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticService {

  private initialized = {
    ga4: false,
    ua: false,
    gtm: false
  };

  initializeTracking(trackingId: string) {
    const type = this.getTrackingType(trackingId);
   if (!type || type.trim() === '') {
      console.log('No se proporcionó un GTAG válido. No se inicializará el Pixel.');
      return;
    }
    // Verifica si ya hay un script activo del mismo tipo
  if (this.initialized[type]) {
    console.warn(`Script ${type} ya está inicializado. Eliminando el anterior...`);
    this.removeScript(type === 'gtm' ? 'gtm-script' : 'ga-script');
  }

    switch(type) {
      case 'gtm':
        this.initializeGTM(trackingId);
        break;
      case 'ga4':
      case 'ua':
        this.initializeGA(trackingId, type);
        break;
    }
  }

  private getTrackingType(id: string): 'ga4' | 'ua' | 'gtm' {
    if (id.startsWith('GTM-')) return 'gtm';
    if (id.startsWith('G-')) return 'ga4';
    if (id.startsWith('UA-')) return 'ua';
    throw new Error('Invalid tracking ID format');
  }

  

  private initializeGTM(gtmId: string) {
    if (this.initialized.gtm) this.removeScript('gtm-script');

    // GTM script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(script);

    // GTM noscript iframe
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    this.initialized.gtm = true;
  }

  private initializeGA(trackingId: string, type: 'ga4' | 'ua') {
    if (this.initialized[type]) this.removeScript('ga-script');
    
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.id = 'ga-script';
    
    // Definir dataLayer y gtag antes de cargar el script
    window.dataLayer = window.dataLayer || [];
    window.gtag = function(...args: any[]) {
        window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    if (type === 'ga4') {
        window.gtag('config', trackingId);
    } else {
        window.gtag('config', trackingId, { 'send_page_view': false });
    }

    document.head.appendChild(script);
    this.initialized[type] = true;
}

private removeScript(id: string) {
  const script = document.getElementById(id);
  if (script) {
    script.remove();
    console.log(`Script ${id} eliminado.`);

    // Restablecer el estado de inicialización
    if (id === 'gtm-script') {
      this.initialized.gtm = false;
    } else if (id === 'ga-script') {
      this.initialized.ga4 = false;
      this.initialized.ua = false;
    }
  } else {
    console.warn(`Script con id ${id} no encontrado.`);
  }
}

trackEvent(eventName: string, eventParams: any = {}, trackingId?: string) {
  if (trackingId) {
    const type = this.getTrackingType(trackingId);

    // Verifica si el script ya está inicializado
    if (!this.initialized[type]) {
      console.warn(`Script ${type} no está inicializado. Inicializando...`);
      this.initializeTracking(trackingId);
    }

    // Envía el evento
    if (type === 'gtm') {
      window.dataLayer.push({
        'event': eventName,
        ...eventParams
      });
    } else if (typeof window.gtag !== 'undefined') {
      window.gtag('event', eventName, eventParams);
    }
  }
}

trackPageView(path: string) {
  const eventParams = { page_path: path };
  this.trackEvent('page_view', {});
}

trackPurchase(trackingId: string, eventParams: any = {}) {
  this.trackEvent('purchase', {});
}

trackBeginCheckout(trackingId: string, eventParams: any = {}) {
  this.trackEvent('begin_checkout', {});
}

trackAddToCart(trackingId: string, eventParams: any = {}) {
  this.trackEvent('add_to_cart', {});
}
  



}
